import { useSelector } from 'react-redux'
import Ad from 'src/features/ads/components/Ad'
import ShowForMediaSize from 'src/components/Responsive/ShowForMediaSize'
import styles from '../../HomePage.module.sass'
import Iav from './children/IAV'
import { mediaTypes } from 'src/services/Ads/constants/adTypes'

const HomeSidebarContent = () => {
  const homeMediumRectangleAd3 = useSelector(
    state => state?.adsReducer.homeMediumRectangle3 || null
  )

  return (
    <ShowForMediaSize showFor={['large']}>
      <Iav />

      {homeMediumRectangleAd3 && (
        <Ad
          {...homeMediumRectangleAd3}
          className={
            styles[
              homeMediumRectangleAd3?.mediaType === mediaTypes.IMAGE
                ? 'homeRectangleAdImage'
                : 'homeRectangleAd'
            ]
          }
        />
      )}
    </ShowForMediaSize>
  )
}

export default HomeSidebarContent
